import type { SupportedLocale } from '../i18n';

export interface OrderLocalitySnapshot {
  readonly delivery_locality_name_ar_snapshot: string | null;
  readonly delivery_locality_name_he_snapshot: string | null;
  readonly delivery_locality_name_en_snapshot: string | null;
  readonly delivery_locality_symbol_number_snapshot: number | null;
  readonly address_city_snapshot: string | null;
}

function cleanText(value: string | null | undefined): string | null {
  const trimmed = value?.trim() ?? '';
  return trimmed === '' ? null : trimmed;
}

export function getOrderLocalityDisplayName(
  order: OrderLocalitySnapshot,
  locale: SupportedLocale,
): string | null {
  const localeSnapshot =
    locale === 'ar'
      ? order.delivery_locality_name_ar_snapshot
      : locale === 'he'
        ? order.delivery_locality_name_he_snapshot
        : order.delivery_locality_name_en_snapshot;

  return (
    cleanText(localeSnapshot) ??
    cleanText(order.delivery_locality_name_ar_snapshot) ??
    cleanText(order.delivery_locality_name_he_snapshot) ??
    cleanText(order.delivery_locality_name_en_snapshot) ??
    cleanText(order.address_city_snapshot)
  );
}
